<template>
  <div class="vl-person-search">
    <div class="queryCondition">
      <div class="search-main">
        <el-select v-model="grouping" @change="sheng" placeholder="省"
                style="width: 120px;margin-right: 10px;">
        <el-option v-for="item in options" :key="item.code" :label="item.name" :value="item.code">
        </el-option>
        </el-select>
        <el-select v-model="shiVal" @change="shi" placeholder="市"
                  style="width: 120px;margin-right: 10px;">
          <el-option v-for="item in cityOptions" :key="item.code" :label="item.name"
                    :value="item.code">
          </el-option>
        </el-select>
        <el-select v-model="quVal" @change="qu" placeholder="区"
                  style="width: 120px;margin-right: 10px;">
          <el-option v-for="item in districOptions" :key="item.code" :label="item.name"
                    :value="item.code">
          </el-option>
        </el-select>
        <el-select v-model="unitId" placeholder="学校" style="width: 150px;margin-right: 10px;">
          <el-option v-for="item in schoolList" :key="item.code" :label="item.name"
                    :value="item.code">
          </el-option>
        </el-select>
        <el-select v-model="openStatus" placeholder="开通状态" style="width: 120px;margin-right: 10px;">
          <el-option v-for="item in stateList" :key="item.value" :label="item.label"
                    :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" @click="getSearchData">查询</el-button>
      </div>
      <div class="search-right">
        <el-button @click="resetQuery">重置</el-button>
      </div>
      
      
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="unitName" label="申请机构" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="scopeName" label="开通范围" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="applyerName" label="联系人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="applyerPhone" label="联系电话" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="auditDate" label="申请时间" width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="applyStatus" label="申请状态" show-overflow-tooltip>
        <template slot-scope="scope">
          {{scope.row.applyStatus == "1" ? "已开通" : scope.row.applyStatus == "2" ? "已驳回" :
          scope.row.applyStatus == "3" ? "申请中" : ""}}
        </template>
      </el-table-column>
      <el-table-column prop="auditDate" label="确认时间" width="160" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="pagination.total > 0" background
      layout="prev, pager, next"
      :current-page.sync="pagination.pageNo"
      :total="pagination.total" @current-change="handleCurrentChange"
      :page-size.sync="pagination.pageSize">
    </el-pagination>
  </div>
</template>
<script>
  import {
    PersonalPostOpenInfoList,
    PersonalPostDicAreaList,
    PersonalPostEudSchoolList
  } from '@/views/index/api/personalCenter/api.personalCenter.js';
  export default {
    data() {
      return {
        appId: null,
        pagination: {
          pageNo: 1,
          pageSize: 10,
          total: 0
        },
        stateList: [
          {
            value: '1',
            label: '已开通'
          },
          {
            value: '0',
            label: '未开通'
          }
        ],
        grouping: "",
        openStatus: "",
        unitId: "",
        areaCode: "",
        shiVal: "",
        quVal: "",
        options: [],
        cityOptions: [],
        tableData: [],
        schoolList: [],
        districOptions: [],
      }
    },
    mounted() {
      this.appId = this.$route.query.appId;
      this.getSearchData();
      this.getArea(1, '');
    },
    methods: {
      //选择省
      sheng(val) {
        this.areaCode = val;
        this.getArea(2, val);
        this.shiVal = "";
        this.quVal = "";
        this.unitId = "";
        this.cityOptions = [];
        this.districOptions = [];
        this.schoolList = [];
      },
      //选择市
      shi(val) {
        this.areaCode = val;
        this.getArea(3, val);
        this.quVal = "";
        this.unitId = "";
        this.districOptions = [];
        this.schoolList = [];
      },
      //选择区
      qu(val) {
        this.areaCode = val;
        this.getSchool(val);
      },
      // 获取机构下拉
      getSchool(code) {
        PersonalPostEudSchoolList({code}).then(res => {
          if (res && res.result) {
            this.schoolList = res.result;
          }
        })
      },
      // 获取省
      getArea(type, code) {
        let params = {
          type: type,
          code: code
        }
        PersonalPostDicAreaList(params).then(res => {
          if (res && res.result) {
            if (type == 1) {
              this.options = res.result;
            } else if (type == 2) {
              this.cityOptions = res.result;
            } else {
              this.districOptions = res.result;
            }
          }
        })
      },
      handleCurrentChange(val) {
        this.pagination.pageNo = val;
        this.getSearchData();
      },
      // 重置
      resetQuery() {
        this.unitId = '';
        this.openStatus = '';
        this.areaCode = '';
        this.grouping = '';
        this.shiVal = '';
        this.quVal = '';
        this.pagination.pageNo = 1;
        this.getSearchData();
      },
      // 获取数据
      getSearchData() {
        let params = {
          appId: this.appId,
          areaCode: this.areaCode,
          openStatus: this.openStatus,
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
          unitId: this.unitId
        }
        PersonalPostOpenInfoList(params).then(res => {
          if (res && res.result) {
            this.tableData = res.result.list;
            this.pagination.total = res.result.totalNum;
          }
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .vl-person-search {
    width: 100%;
    .el-pagination {
      text-align: center;
      margin: 30px 0 50px;
    }
    .queryCondition {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }
    .queryCondition .el-button {
      padding: 10px 24px !important;
    }
    .queryCondition .el-button--default {
      border: 1px solid #4286F5 !important;
      color: #4286F5 !important;
    }
    .has-gutter tr th{
      background-color: #F1F8FF !important;
      border-bottom: none !important;
    }
  }
</style>